<template>
  <div
    id="top"
    :style="bgStyle"
  >
    <!-- 视频播放按钮 -->
    <img
      id="play"
      src="../assets/images/play.png"
      @click.stop="toggleVideo(true)"
    />
    <div class="title0">
      <!-- 主标题 -->
      <img
        id="title"
        :src="mainTitle"
        :style="newMainTitleStyle"
      />
      <!-- 副标题 -->
      <img
        id="title2"
        :src="subTitle"
        :style="newSubTitleStyle"
      />
      <!-- 公告导航 -->
      <div class="title3">
        <div class="title-anno">
          <!-- left -->
          <div class="title-anno-left">
            <span class="title-anno-left-icon">
              <img src="../assets/images/202603/nav-anno/icon2.png">
            </span>
            <span class="title-anno-left-text">
              {{ $t("announcement.publishTime") }}
            </span>
          </div>
          <!-- middle -->
          <div
            class="title-anno-middle"
            @click="isAnnouncementModalShow = true"
          >
            <div class="title-anno-middle-scroll">
              <span class="title-anno-middle-scroll-text">
                {{ $t("announcement.title") }}
              </span>
            </div>
          </div>
          <!-- right -->
          <div
            class="title-anno-right"
            @click="isAnnouncementModalShow = true"
          >
            <span class="title-anno-right-text">查看更多</span>
            <div class="title-anno-right-icon">
              <img src="../assets/images/202603/nav-anno/arrow.png">
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 下载按钮 -->
    <div :class="['shop', $i18n.locale === 'zh' ? 'shop-zh' : '']">
      <a
        v-for="link, idx in links[this.$i18n.locale]"
        :key="idx"
        :href="link.href"
        target="_blank"
      >
        <img
          :src="link.icon"
          class="shop-img"
        />
      </a>
    </div>
    <!-- 公告按钮 -->
    <!-- <div class="announcement">
      <a>
        <img
          v-show="this.$i18n.locale == 'zh'"
          src="../assets/images/202602/announcement/btn/cn.png"
          class="announcement-img"
          @click="openDialog"
        >
        <img
          v-show="this.$i18n.locale == 'en'"
          src="../assets/images/202602/announcement/btn/en.png"
          class="announcement-img"
          @click="openDialog"
        >
        <img
          v-show="this.$i18n.locale == 'ja'"
          src="../assets/images/202602/announcement/btn/jp.png"
          class="announcement-img"
          @click="openDialog"
        >
      </a>
    </div> -->
    <!-- 审查 censor -->
    <div class="censor">
      <img
        v-show="this.$i18n.locale == 'zh'"
        src="../assets/images/202510/censor/zh.png"
        class="censor-img"
      />
      <img
        v-show="this.$i18n.locale == 'en'"
        src="../assets/images/202510/censor/en.png"
        class="censor-img"
      />
      <img
        v-show="this.$i18n.locale == 'en'"
        src="../assets/images/202510/censor/en1.png"
        class="censor-img2"
      />
      <img
        v-show="this.$i18n.locale == 'ja'"
        src="../assets/images/202510/censor/ja-new.svg"
        class="censor-img"
      />
    </div>

    <div class="logo">
      <img
        src="../assets/images/202510/censor/logo.png"
        class="logo-img"
      />
    </div>

    <div
      id="top-video"
      v-if="topVideoShow"
      @click.self="toggleVideo(false)"
    >
      <video
        id="top-video-play"
        :src="getHomeVideoUrl"
        autoplay
        loop
        volume="0.5"
        preload="metadata"
        controls
      >
        {{ $t("role.playerWarning") }}
      </video>
      <img
        id="top-video-close"
        src="../assets/images/close.png"
        @click.stop="toggleVideo(false)"
      />
    </div>
    <!-- 公告弹窗 -->
    <div
      class="modal-mask"
      v-if="isAnnouncementModalShow"
      @click="closeDialogByMask"
    >
      <div
        class="modal-content"
        @click.stop
      >
        <div class="title-area">
          <span class="main-title">
            {{ $t("announcement.title") }}
          </span>
          <span class="sub-title">
            {{ $t("announcement.subTitle") }}
          </span>
        </div>
        <div
          class="content-area"
          v-html="$t('announcement.content')"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    const ua = navigator.userAgent.toLowerCase();
    const isOpenHarmony = /openharmony/i.test(ua);
    const isIOS = /iphone|ipad|ipod/i.test(ua);
    let mobileUrl = "https://acecn-mobile-volc-pkg-cdn.91act.com/bbee/blazblueentropyeffect_1.1.4_140166_3_OriginalCN.apk";

    if (isOpenHarmony) {
      mobileUrl = "https://appgallery.huawei.com/app/C111687743";
    } else if (isIOS) {
      mobileUrl = "https://apps.apple.com/cn/app/id6497877633";
    }

    return {
      // 定时更换背景图
      switchTime: "2026-02-12 00:00:00",
      oldBgUrl: require("../assets/images/202510/bg.png"),
      newBgUrl: require("../assets/images/202602/bg.png"),
      timer: null,
      hasSwitched: false,
      // 显示公告弹窗
      isAnnouncementModalShow: false,
      // 显示 video
      topVideoShow: false,
      links: {
        zh: [
          // { icon: require(`../assets/images/202510/shop/${this.$i18n.locale}/ps.png`), href: "https://store.playstation.com/zh-hans-hk/concept/10013958" },
          // { icon: require(`../assets/images/202510/shop/${this.$i18n.locale}/ns.png`), href: "https://ec.nintendo.com/HK/zh/titles/70010000105929" },
          // { icon: require(`../assets/images/202602/shop/xbox.png`), href: "https://www.xbox.com/en-US/games/store/blazblue-entropy-effect-x/9n8h4rrsrv2s/" }
          { icon: require(`../assets/images/202603/top-icons/${this.$i18n.locale}/ns.png`), href: "https://ec.nintendo.com/HK/zh/titles/70010000105929" },
          { icon: require(`../assets/images/202603/top-icons/${this.$i18n.locale}/mobile.png`), href: mobileUrl },
          { icon: require(`../assets/images/202603/top-icons/${this.$i18n.locale}/xbox.png`), href: "https://www.xbox.com/en-US/games/store/blazblue-entropy-effect-x/9n8h4rrsrv2s/" },
          { icon: require(`../assets/images/202603/top-icons/${this.$i18n.locale}/ps.png`), href: "https://store.playstation.com/zh-hans-hk/concept/10013958" },
        ],
        en: [
          { icon: require(`../assets/images/202510/shop/${this.$i18n.locale}/ps.png`), href: "https://store.playstation.com/en-us/concept/10013958" },
          { icon: require(`../assets/images/202510/shop/${this.$i18n.locale}/ns.png`), href: "https://www.nintendo.com/us/store/products/blazblue-entropy-effect-x-switch/" },
          { icon: require(`../assets/images/202602/shop/xbox.png`), href: "https://www.xbox.com/en-US/games/store/blazblue-entropy-effect-x/9n8h4rrsrv2s/" }
        ],
        ja: [
          { icon: require(`../assets/images/202510/shop/${this.$i18n.locale}/ps.png`), href: "https://store.playstation.com/ja-jp/concept/10013958" },
          { icon: require(`../assets/images/202510/shop/${this.$i18n.locale}/ns.png`), href: "https://store-jp.nintendo.com/item/software/D70010000105928" },
          { icon: require(`../assets/images/202602/shop/xbox.png`), href: "https://www.xbox.com/en-US/games/store/blazblue-entropy-effect-x/9n8h4rrsrv2s/" }
        ]
      }
    }
  },
  methods: {
    toggleVideo(bol) {
      this.topVideoShow = bol
      let body = document.getElementsByTagName("body")[0]
      if (bol) {
        body.style.overflow = "hidden"
      } else {
        body.style.overflow = null
      }
    },
    openDialog() {
      this.isAnnouncementModalShow = true
    },
    closeDialogByMask() {
      this.isAnnouncementModalShow = false
    },
    getTimeDiff() {
      // 目标时间
      const targetTime = new Date(this.switchTime).getTime()
      // 当前时间
      const nowTime = new Date().getTime()
      return targetTime - nowTime
    },
    initBgSwitchTimer() {
      const timeDiff = this.getTimeDiff()

      // 4. 判断是否需要设置定时器
      if (timeDiff <= 0) {
        // 如果当前时间已过指定时间，直接切换
        this.switchBgAndTitle()
      } else {
        // 否则设置单次定时器，到点后切换
        this.timer = setTimeout(() => {
          this.switchBgAndTitle()
        }, timeDiff)
      }
    },
    switchBgAndTitle() {
      if (!this.hasSwitched) {
        this.hasSwitched = true
      }
    }
  },
  computed: {
    timeDiff() {
      const targetTime = new Date(this.switchTime).getTime()
      const nowTime = new Date().getTime()
      return targetTime - nowTime
    },
    getHomeVideoUrl() {
      return `https://bbeex.91act.com/videos/pv-aio-${this.$i18n.locale}.webm`
    },
    bgStyle() {
      return {
        background: `url("${this.hasSwitched ? this.newBgUrl : this.oldBgUrl}") no-repeat center / 100%`,
      }
    },
    // showVideoBtn() {
    //   return this.hasSwitched
    //     ? {
    //       display: "none",
    //     }
    //     : ""
    // },
    mainTitle() {
      const locale = this.$i18n.locale
      return this.hasSwitched
        ? require(`../assets/images/202602/title/${locale}/main.png`)
        : require(`../assets/images/202510/title-${locale}.png`)
    },
    subTitle() {
      const locale = this.$i18n.locale
      return this.hasSwitched
        ? require(`../assets/images/202602/title/${locale}/sub.png`)
        : require(`../assets/images/202510/title2-${locale}.png`)
    },
    newMainTitleStyle() {
      return this.hasSwitched
        ? {
          position: "absolute",
          maxWidth: "7.6rem", // 限制最大宽度，避免大屏下过大
          height: "auto", // 自动计算高度，保持图片原始宽高比
          bottom: "50vw", // 底部距离也改用vw，适配不同视口
          left: "50%", // 可选：居中对齐（如果需要）
          transform: "translateX(-50%)" // 可选：配合left:50%实现水平居中
        }
        : ""
    },
    newSubTitleStyle() {
      return this.hasSwitched
        ? {
          position: "absolute",
          // 同理：根据subTitle的原始尺寸换算vw，示例值请根据实际调整
          // width: "28vw",
          // maxWidth: "450px", // 替换为subTitle的最大宽度
          height: "auto",
          bottom: "31vw", // 适配底部距离
          left: "50%",
          transform: "translateX(-50%)"
        }
        : ""
    },
  },
  mounted() {
    this.initBgSwitchTimer()
    if (this.$route.path == "/announcement") {
      this.isAnnouncementModalShow = true
    }
  },
  beforeDestroy() {
    // 组件销毁前清除定时器
    if (this.timer) {
      clearTimeout(this.timer)
      this.timer = null
    }
  },
}
</script>

<style scoped>
#top {
  width: 750px;
  height: 1168px;
  position: relative;
  /* background-image: url("../assets/images/202510/bg.png");
  background-repeat: no-repeat;
  background-size: 100%; */
}

#top-main {
  width: 100%;
  position: absolute;
  top: 188px;
  left: 50%;
  margin-left: -339px;
}

.title0 {
  display: flex;
  position: absolute;
  width: 750px;
  height: 100%;
  justify-content: center;
  align-items: center;
}

#title {
  width: 750px;
  height: 152px;
  position: absolute;
  bottom: 21%;
}

#title2 {
  width: 750px;
  height: 35px;
  position: absolute;
  bottom: 19%;
}

#play {
  display: block;
  width: 480px;
  height: 106px;
  position: absolute;
  left: 50%;
  top: calc(50% - 20px);
  transform: translate(-50%, -50%);
}

#download {
  display: block;
  width: 327px;
  height: 119px;
  margin: 495px auto 0;
}

#url-table {
  margin: 0 auto;
}

.url-td {
  line-height: 0;
}

.btns {
  width: 158px;
  height: 58px;
}

#notice {
  width: 84px;
  height: 110px;
  position: absolute;
  right: 20px;
  bottom: 50px;
}

#top-video {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 9;
  background: rgba(0, 0, 0, .8);
}

#top-video-play {
  width: 100%;
  height: auto;
  position: absolute;
  top: 350px;
  left: 0;
}

#top-video-close {
  width: 39px;
  height: 39px;
  position: absolute;
  right: 50px;
  top: 280px;
  z-index: 99;
}

.title3 {
  width: 100%;
  height: 47px;
  display: flex;
  position: absolute;
  justify-content: center;
  bottom: 31vw;
}

.title-anno {
  display: flex;
  position: absolute;
  justify-content: center;
  align-items: center;
  width: 8rem;
  height: 100%;
  /* bottom: 130px;
  width: 432px;
  height: 47px; */
  background-image: url("../assets/images/202603/nav-anno/bg.png");
  background-repeat: no-repeat;
  background-size: 100%;
}

.title-anno-left {
  display: flex;
  position: absolute;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 23%;
  left: 0;
}

.title-anno-left-icon {
  height: 100%;
  width: 22px;
  left: 0;
  margin: 0 8px;
  align-items: center;
  justify-content: center;
  position: absolute;
  display: flex;
}

.title-anno-left-icon > img {
  height: 19px;
  width: 22px;
}

.title-anno-left-text {
  font-family: "MiSans-Medium";
  color: red;
  cursor: default;
  display: flex;
  position: absolute;
  right: 0;
  height: 100%;
  width: calc(100% - 35px);
  justify-content: center;
  align-items: center;
}

.title-anno-middle {
  flex: 1;
  height: 100%;
  width: 55%;
  left: 23%;
  overflow: hidden;
  display: flex;
  position: absolute;
  margin: 0 8px;
  justify-content: center;
  align-items: center;
}

.title-anno-middle-scroll {
  position: absolute;
  white-space: nowrap;
  color: red;
  font-family: "MiSans-Medium";
  line-height: 100%;
  cursor: pointer;
  width: 100%;
  display: flex;
  animation: none;
}

.title-anno-middle-scroll-text {
  animation: scroll-left 15s linear infinite;
  justify-content: center;
  align-items: center;
}

@keyframes scroll-left {
  0% {
    /* 初始位置：左对齐 */
    transform: translateX(0);
  }

  20% {
    /* 延迟结束，开始滚动 */
    transform: translateX(0);
  }

  100% {
    /* 最后10%时长回到右侧外（准备下一轮） */
    transform: translateX(-100%);
  }
}

.title-anno-link {
  color: red;
  font-family: "MiSans-Medium";
  cursor: pointer;
  text-decoration: none;
}

.title-anno-right {
  right: 0;
  width: 19%;
  height: 100%;
  margin: 0 8px;
  display: flex;
  position: absolute;
  cursor: pointer;
}

.title-anno-right-text {
  display: flex;
  position: absolute;
  height: 100%;
  justify-content: center;
  align-items: center;
  font-family: "MiSans-Medium";
  color: #888888;
  margin: 0 4px;
}

.title-anno-right-icon {
  height: 100%;
  width: 1.4375rem;
  /* right: -30px; */
  right: -0.55rem;
  display: flex;
  position: absolute;
  justify-content: center;
  align-items: center;
}

.title-anno-right-icon > img {
  height: 15px;
  width: 23px;
}

.group-cn-inline {
  display: flex;
  position: absolute;
  height: 64px;
  left: 50%;
  transform: translate(-50%, -50%);
  margin-top: 550px;
}

.group-cn-inline > a:first-child {
  margin-left: 0;
}

.group-cn-inline > a {
  height: 100%;
  margin-left: 5px;
}

.group-cn-inline > a > img {
  height: 100%;
}

.group-cn-preview {
  display: flex;
  position: absolute;
  height: 40px;
  left: 50%;
  transform: translate(-50%, -50%);
  margin-top: 490px;
}

.group-cn-inline-preview {
  display: flex;
  position: absolute;
  height: 64px;
  left: 50%;
  transform: translate(-50%, -50%);
  margin-top: 80px;
}

.group-cn-inline-preview > a:first-child {
  margin-left: 0;
}

.group-cn-inline-preview > a {
  height: 100%;
  margin-left: 5px;
}

.group-cn-inline-preview > a > img {
  height: 100%;
}

.pointer-none {
  pointer-events: none;
}

.censor {
  width: auto;
  height: 59px;
  top: 20px;
  left: 20px;
  position: absolute;
  display: inline-flex;
  justify-self: center;
  align-items: center;
}

.censor-img {
  width: 36px;
  height: 46px;
  padding-right: 3px;
}

.censor-img2 {
  width: 103px;
  height: 46px;
  padding-right: 3px;
}

.logo {
  width: auto;
  height: 30px;
  position: absolute;
  top: 20px;
  right: 20px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  z-index: 30;
}

.logo-img {
  width: 101px;
  height: 30px;
}

.shop {
  position: absolute;
  display: inline-flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  bottom: 100px;
}

.shop-zh {
  display: grid !important;
  grid-template-columns: auto auto;
  justify-content: center;
  bottom: 8vw;
}

.shop-img {
  width: 202px;
  max-height: 93px;
}

.announcement {
  position: absolute;
  display: inline-flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  bottom: 55px;
}

.announcement-img {
  width: 400px;
  height: 100%;
}

.modal-mask {
  position: fixed;
  top: 0;
  left: 0;
  max-width: 750px;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  cursor: pointer;
  backdrop-filter: blur(2px);
}

.modal-content {
  width: 85%;
  height: 70%;
  background-image: url("../assets/images/202602/announcement/bg.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}

.title-area {
  height: 20%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  color: white;
}

.main-title {
  font-size: 24px;
  font-family: "MiSans-Bold";
  font-weight: bold;
  display: flex;
  position: relative;
  width: 93%;
  align-items: center;
  justify-content: center;
}

.sub-title {
  font-size: 18px;
  font-family: "MiSans-Bold";
  margin: 0;
  display: flex;
  position: relative;
  align-items: center;
  justify-content: center;
}

.content-area {
  color: white;
  display: flex;
  flex-direction: column;
  position: relative;
  top: -20px;
  width: 89%;
  margin: 0 auto;
  font-family: "MiSans-Bold";
  font-size: 18px;
  line-height: 1.4;
}
</style>
